import { useState } from "react";

export const useLocale = () => {
  const [locale, setLocale] = useState("en");
  const [collator, setCollator] = useState(
    new Intl.Collator("en", {
      numeric: true,
      sensitivity: "base",
    })
  );

  const changeLocale = (locale: string) => {
    setLocale(locale);
    setCollator(
      new Intl.Collator(locale, {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  return { locale, changeLocale, collator };
};
